import { render, staticRenderFns } from "./GroupJobAnnouncementUserReports.vue?vue&type=template&id=6458fffe"
import script from "./GroupJobAnnouncementUserReports.vue?vue&type=script&lang=js"
export * from "./GroupJobAnnouncementUserReports.vue?vue&type=script&lang=js"
import style0 from "./GroupJobAnnouncementUserReports.vue?vue&type=style&index=0&id=6458fffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports